import React, { Component } from 'react';
import { connect } from "react-redux";
import { SaveComments, UpdateComments} from "action/workorderAction";
import user_svg from 'Assets/icons/Icons__error.svg';
import styles from './maintenance.module.css';


class AddCommentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayErrorMessages: false,
            comment: null,
        }

        this.textareaValueChange = this.textareaValueChange.bind(this);
        this.submitCommentForm = this.submitCommentForm.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    componentDidMount(){
       // console.log(this.props);
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps);
    //     if (this.props !== nextProps) {
    //        console.log(nextProps);
    //     }
    // }

    textareaValueChange(){ this.setState({comment:this.refs.comment.value, displayErrorMessages: false}); } //Updating text area comment.
    closePopUp(){  this.props.onCloseModal(); }

    render() {
        let { displayErrorMessages} = this.state;
        let {editcommentData}=this.props;
       

        return (
            <div>
                <div  className={styles.modalHeader}> 
                    <h3 className={styles.subTitle}>Add Comment</h3>
                    <span className={styles.modalClose} onClick={this.closePopUp}>X</span>
                 </div>

                <div className={styles.modalContentContainer}>
                    <div className={styles.modalContent}><p className={(displayErrorMessages) ? styles.error_formLabel : styles.formLabel} >Comment*</p>
                        <textarea defaultValue={(editcommentData !==null)?editcommentData:""} 
                        className={(displayErrorMessages) ? styles.comment_error_textarea : styles.comment_textarea} 
                        rows="8" ref='comment' 
                        onChange={this.textareaValueChange} 
                        maxLength="1000" ></textarea>
                      
                        <span className={styles.errorspan} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}><img src={user_svg} alt="Trane Logo" height="25px" width="25px" /></span>  <br />        {/* Error Icon */}
                        <p className={styles.errorMessagge} style={{ display: (displayErrorMessages) ? 'initial' : 'none' }}>An entry is required.</p>      {/* Required Error message */}
                    </div>
                </div>
                
                <div  className={styles.modalFooter}>
                    <p className={styles.CommentrequiredFieldText}>* required fields.</p>
                    <button className={styles.commentCancelButton} onClick={this.closePopUp}>CANCEL</button>
                    <button className={styles.commentSaveButton} onClick={this.submitCommentForm}>SAVE</button>
                </div>

            </div>
        );
    }


    //Submit maintenance form 
    submitCommentForm() {
        let { comment } = this.state;
        if (comment !== null && comment !== "") {
           
            var data = {
                Comments: comment,
                CreatedByUserID: this.props.createdUserID,
                WorkOrderID: this.props.workOrderID,
                commentId: this.props.editcommentID
            }

            if (this.props.editcommentID !== 0)
            this.props.SaveComments(data);
             else
            this.props.UpdateComments(data);

            this.props.onCloseModal();
        }
        else {
            this.setState({ displayErrorMessages: true });
        }
    }

}


const mapDispatchToProps = dispatch => {
    return {
        SaveComments: (data) => dispatch(SaveComments(data)),
        UpdateComments: (data) => dispatch(UpdateComments(data)),
    };
};

export default connect(null, mapDispatchToProps)(AddCommentModal);